import React, { useState } from 'react';
import InternalNotes from './internalNotes';
import DisciplinaryFault from './diciplinaryFault';

const Discipline = ({ internalId, onUpdate }) => {
  const [showDisciplinary, setShowDisciplinary] = useState(false);
  const [showInternalNotes, setShowInternalNotes] = useState(false);

  return (
    <div>
      <div className='container-btn-diciplina'>
        {/* Botões para abrir os modais */}
        <button onClick={() => setShowDisciplinary(true)} className="discipline-btn discipline-action-btn discipline-action-btn--fault">
          <span className="discipline-action-btn-icon">+</span>
          <span>Adicionar Falta</span>
        </button>
        <button onClick={() => setShowInternalNotes(true)} className="discipline-btn discipline-action-btn discipline-action-btn--note">
          <span className="discipline-action-btn-icon">+</span>
          <span>Adicionar Nota</span>
        </button>
      </div>

      {/* Modais */}
      {showDisciplinary && (
        <DisciplinaryFault
          internalId={internalId}
          onClose={() => setShowDisciplinary(false)}
          onUpdate={onUpdate} // Atualiza a timeline de faltas
        />
      )}

      {showInternalNotes && (
        <InternalNotes
          internalId={internalId}
          onClose={() => setShowInternalNotes(false)}
          onUpdate={onUpdate} // Atualiza a timeline de notas
        />
      )}
    </div>
  );
};

export default Discipline;
